import { makeStyles } from "@material-ui/core";

const COMPLETED_COLOR = "#1976D2";
const UPCOMING_COLOR = "#FB8C00";
const QUEUE_COLOR = "#009688";
const CANCELLED_COLOR = "#9E9E9E";
const MISSING_COLOR = "#d32f2f";

export const SIDEBAR_COLORS = {
  COMPLETED: COMPLETED_COLOR,
  UPCOMING: UPCOMING_COLOR,
  QUEUE: QUEUE_COLOR,
  CANCELLED: CANCELLED_COLOR,
  MISSING: MISSING_COLOR,
};

export const useSidebarStyles = makeStyles((theme) => ({
  sidebarCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2.5),
    height: "100%",
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  headerIcon: {
    color: theme.palette.primary.main,
  },
  sidebarTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  miniCal: {
    border: "1px solid #eef0f3",
    borderRadius: 12,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2.5),
  },
  miniCalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  miniCalMonth: {
    fontSize: "0.85rem",
    fontWeight: 700,
    color: "#1f2937",
    textTransform: "uppercase",
  },
  miniCalNav: {
    padding: 4,
    color: "#6b7280",
  },
  miniCalGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: 2,
  },
  miniCalWeekday: {
    textAlign: "center",
    fontSize: "0.7rem",
    fontWeight: 700,
    color: "#9aa4b2",
    padding: "4px 0",
  },
  miniCalDay: {
    textAlign: "center",
    fontSize: "0.78rem",
    padding: "6px 0",
    borderRadius: 8,
    cursor: "pointer",
    color: "#374151",
    "&:hover": { backgroundColor: "#eef4ff" },
  },
  miniCalDayMuted: {
    color: "#cbd5e1",
  },
  miniCalDayToday: {
    border: "1px solid #1162FE",
    color: "#1162FE",
    fontWeight: 700,
  },
  miniCalDaySelected: {
    backgroundColor: "#1162FE",
    color: "#fff",
    fontWeight: 700,
    "&:hover": { backgroundColor: "#0d4fd0" },
  },
  section: {
    marginBottom: theme.spacing(2),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sectionDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
  sectionLabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
  apptCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.25),
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
    borderLeft: "3px solid #cbd5e1",
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: "#f1f5f9",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    },
  },
  // Cancelled cards are kept for history but must not read as actionable.
  apptCardInert: {
    cursor: "default",
    backgroundColor: "#f3f4f6",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },
  apptCardLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    minWidth: 0,
  },
  apptCardText: {
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#1f2937",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  statusChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: "0.7rem",
    fontWeight: 600,
    padding: "2px 8px",
    borderRadius: 999,
    whiteSpace: "nowrap",
  },
  onlineChip: {
    backgroundColor: "#e7f7ee",
    color: "#0a8f54",
  },
  offlineChip: {
    backgroundColor: "#eef2ff",
    color: "#4f46e5",
  },
  statusIcon: {
    fontSize: "0.95rem",
  },
  openVisitBtn: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    boxShadow: "none",
  },
  emptySection: {
    fontSize: "0.78rem",
    color: "#9aa4b2",
    fontStyle: "italic",
    padding: theme.spacing(0.5, 0, 1),
  },
}));
